import React, { useContext } from "react";
import ThemeContext from "../context/ThemeContext";
import "./Switch.css";

export default function Switch() {
  const { dark, toggle } = useContext(ThemeContext)
  const status = dark ? true : false

  return (
    <label className="switch" htmlFor="checkbox">
      <input
        type="checkbox"
        id="checkbox"
        onChange={() => toggle()}
        checked={status}
      />
      <div className="slider round"></div>
    </label>
  );
};
